import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { StandaloneCheckbox } from 'web-ui-components/lib/data/capture';

const Terms = ({ isTermsChecked, onConfirmationCheckboxChange, isFormSubmit }) => (
  <Content>
    {({
      openBusinessAccountTermsLabel = '',
      openBusinessAccountTermsAgreement = '',
      openBusinessAccountTermsError = ''
    }) => (
      <Field name="openBusinessAccountTerms" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            name="openBusinessAccountTermsAgreement"
            validationMessage={!isTermsChecked && isFormSubmit ? openBusinessAccountTermsError : ''}
          >
            <Field
              name="openBusinessAccountTermsAgreement"
              value={openBusinessAccountTermsAgreement}
              type="checkbox"
            >
              {({ input }) => (
                <StandaloneCheckbox
                  id="openBusinessAccountTermsAgreement"
                  isChecked={isTermsChecked}
                  labelText={openBusinessAccountTermsLabel}
                  onChange={({ isChecked }) => {
                    input.onChange(isChecked);
                    onConfirmationCheckboxChange(isChecked);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default Terms;
